import React from 'react';
import cn from 'classnames';

class Items extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onMCChange = this.onMCChange.bind(this);

    let checks = {};
    this.props.project.items_to_buy.forEach(group => {
      group.values.forEach(item => {
        checks[item.id] = item.checked;
      });
    });

    this.state = checks;
  }

  onMCChange(id) {
    let check = {};
    check[id] = !this.state[id];
    this.setState(check, () => {
      this.props.updateMC(this.state);
    });
  }

  onChange(e) {
    this.props.updateProject(
      { questionnaire_attributes: { items_to_source: e.target.value } },
      formContext => {
        let data = formContext.state;
        data.questionnaire.items_to_source = e.target.value;
        formContext.setState(data);
      },
    );
  }

  getSelectedCount(columns) {
    let count = 0;
    columns.forEach(columnGroup => {
      columnGroup.forEach(group => {
        group.values.forEach(value => {
          if (this.state[value.id]) {
            count++;
          }
        });
      });
    });
    return count;
  }

  render() {
    const project = this.props.project;
    const groups = project.items_to_buy;
    const groupedGroups = [];
    let groupedTemp = [],
      groupedCnt = 0;
    groups.forEach((group, index) => {
      groupedCnt = groupedCnt + group.values.length;
      groupedTemp.push(group);
      if (index == 0 || index + 1 == groups.length || groupedCnt > 6) {
        groupedGroups.push(groupedTemp);
        groupedTemp = [];
        groupedCnt = 0;
      }
    });

    const listItems = [];
    const selectedCount = this.getSelectedCount(groupedGroups);
    groupedGroups.forEach((colGroups, cgIdx) => {
      let colItems = [];
      colGroups.forEach((group, gIdx) => {
        colItems.push(
          <div className="onboarding-selection_subtitle" key={'d' + gIdx}>
            {group.name}
          </div>,
        );
        group.values.forEach((item, iIdx) => {
          let disabled =
            project.max_categories &&
            !this.state[item.id] &&
            selectedCount >= project.max_categories || this.props.disabled;
          colItems.push(
            <input
              key={'i' + gIdx + '-' + iIdx}
              id={'item-' + item.id}
              className="onboarding-selection_input"
              type="checkbox"
              checked={this.state[item.id]}
              onChange={() => {
                this.onMCChange(item.id);
              }}
              disabled={disabled}
            />,
          );
          colItems.push(
            <label
              key={'l' + gIdx + '-' + iIdx}
              htmlFor={'item-' + item.id}
              className="onboarding-selection_label"
            >
              {item.name}
            </label>,
          );
        });
      });
      listItems.push(
        <div className="onboarding-selection_col" key={cgIdx}>
          {colItems}
        </div>,
      );
    });

    return (
      <div className={cn('onboarding-selection', { '-disabled': this.props.disabled })}>
        {listItems}
        <div className="onboarding-selection_col -full-line">
          <div className="onboarding-selection_other-items">
            <div className="onboarding-selection_subtitle">Other items</div>
            <textarea
              className="form-control"
              placeholder="Anything we missed out?"
              rows="3"
              value={this.props.project.questionnaire.items_to_source}
              onChange={this.onChange}
              disabled={this.props.disabled}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Items;



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/UI/Items.js